<template>
  <div @keydown="handleKeydown">
    <el-row justify="end" align="middle" class="helper-text-wrapper" v-if="(fieldsHaveHelperText && helperText) || errMsg">
      <el-tag :type="errMsg ? 'danger' : 'gray'" :style="`visibility: ${helperText || errMsg ? 'visible' : 'hidden'};`">
        {{ errMsg ? errMsg : helperText }}
      </el-tag>
    </el-row>
    <el-row type="flex" justify="center" align="middle">
      <el-form :model="form" ref="newEntityForm">
        <table>
          <tr v-for="(row, index) in getRows()">
            <td v-if="row[0]">
              {{ row[0].required ? `*${row[0].label || row[0].name }` : (row[0].label || row[0].name )}}
            </td>
            <td v-if="row[0]" :style="row[0].fieldType === 'filler' ? 'background-color: #efefef' : 'background-color: #fff'">
              <el-input
                class="keynav"
                v-if="row[0].fieldType === 'input' && !row[0].autocomplete"
                v-model="form[row[0].name]"
                :tabindex="row[0].tabIndex"
                :ref="`${idPrefix}${index + 1}`"
                :id="idPrefix + (index + 1)"
                :name="row[0].name"
                :disabled="row[0].disabled"
                data-fieldtype="input"
                @focus="updateFocusedField"
                @blur="row[0].name.includes('address_') ? handleAddressFieldBlurEvent(row[0].name) : null"
                @change="() => change(row[0].name)"
              />
              <MoneyField
                class="keynav"
                style="padding-left: 12px;"
                :tabindex="row[0].tabIndex"
                :ref="`${idPrefix}${index + 1}`"
                :id="idPrefix + (index + 1)"
                :name="row[0].name"
                :disabled="row[0].disabled"
                :decimals="row[0].decimals || undefined"
                v-if="row[0].fieldType === 'money'"
                v-model="form[row[0].name]"
                data-fieldtype="input"
                @focus="updateFocusedField"
                @blur="() => change(row[0].name)"
                @change="() => change(row[0].name)"
              />
              <el-autocomplete
                class="keynav"
                placeholder="Type to search..."
                @select="handleSelect"
                :tabindex="row[0].tabIndex"
                :ref="`autocomplete__${idPrefix}${index + 1}`"
                :id="idPrefix + (index + 1)"
                :name="row[0].name"
                :disabled="row[0].disabled"
                :fetch-suggestions="row[0].searchAsync
                  ? querySearchAsync
                  : (query, cb) => autocompleteLocalSearch({ query, ref: `autocomplete__${idPrefix}${index + 1}`, field: row[0] }, cb)"
                :props="{ label: 'label', value: 'value' }"
                :trigger-on-focus="row[0].triggerOnFocus"
                v-else-if="row[0].fieldType === 'autocomplete'"
                v-model="form[row[0].name].label"
                data-fieldtype="autocomplete"
                @blur="row[0].name.includes('address_') ? handleAddressFieldBlurEvent(row[0].name) : null"
                @change="() => change(row[0].name)"
              />
              <el-select
                class="keynav"
                v-else-if="row[0].fieldType === 'select' && form[row[0].name].hasOwnProperty('value')"
                v-model="form[row[0].name].value"
                :tabindex="row[0].tabIndex"
                :ref="`${idPrefix}${index + 1}`"
                :id="idPrefix + (index + 1)"
                :name="row[0].name"
                :filterable="row[0].filterable"
                :multiple="row[0].multiple"
                :loading="null"
                :placeholder="row[0].filterable ? 'Search' : 'Select option'"
                no-match-text=" "
                @change="() => handleSelectChange(row[0].name)"
                data-fieldtype="select">
                <el-option
                  v-for="item in row[0].choices ? row[0].choices : nonAsyncSuggestions[row[0].name]"
                  :key="item.value"
                  :label="row[0].choices ? item.display_name : item.label"
                  :value="item.value"
                />
              </el-select>
              <el-select
                class="keynav"
                v-else-if="row[0].fieldType === 'select' && !form[row[0].name].hasOwnProperty('value')"
                v-model="form[row[0].name]"
                :tabindex="row[0].tabIndex"
                :ref="`${idPrefix}${index + 1}`"
                :id="idPrefix + (index + 1)"
                :name="row[0].name"
                :filterable="row[0].filterable"
                :multiple="row[0].multiple"
                :loading="null"
                :placeholder="row[0].filterable ? 'Search' : 'Select option'"
                no-match-text=" "
                @change="() => handleSelectChange(row[0].name)"
                data-fieldtype="select">
                <el-option
                  v-for="item in row[0].choices ? row[0].choices : nonAsyncSuggestions[row[0].name]"
                  :key="item.value"
                  :label="row[0].choices ? item.display_name : item.label"
                  :value="item.value"
                />
              </el-select>
              <el-checkbox
                class="keynav form-checkbox"
                :tabindex="row[0].tabIndex"
                :ref="`${idPrefix}${index + 1}`"
                :id="idPrefix + (index + 1)"
                :name="row[0].name"
                v-else-if="row[0].fieldType === 'checkbox'"
                v-model="form[row[0].name]"
                data-fieldtype="checkbox"
                @focus="updateFocusedField"
                @change="() => change(row[0].name)"
              />
              <el-input
                class="keynav"
                type="textarea"
                :tabindex="row[0].tabIndex"
                :ref="`${idPrefix}${index + 1}`"
                :id="idPrefix + (index + 1)"
                :name="row[0].name"
                :rows="1"
                v-else-if="row[0].fieldType === 'textarea'"
                v-model="form[row[0].name]"
                data-fieldtype="input"
                @focus="updateFocusedField"
                @change="() => change(row[0].name)"
              />
              <el-input
                class="keynav"
                placeholder="YYYY-MM-DD"
                :ref="`${idPrefix}${index + 1}`"
                :id="idPrefix + (index + 1)"
                :name="row[0].name"
                v-else-if="row[0].fieldType === 'date'"
                v-model="form[row[0].name]"
                @focus="updateFocusedField"
                data-fieldtype="input"
                @blur="formatDateFields"
                @change="() => change(row[0].name)"
              />
            </td>
            <td v-if="row[1]">
              {{ row[1].required ? `*${row[1].label || row[1].name }` : (row[1].label || row[1].name )}}
            </td>
            <td
              v-if="row[1]"
              :style="row[1].fieldType === 'filler' ? 'background-color: #efefef' : 'background-color: #fff'">
              <el-input
                class="keynav"
                :tabindex="row[1].tabIndex"
                :ref="idPrefix + (index + (Object.keys(getRows()).length) + 1)"
                :id="idPrefix + (index + (Object.keys(getRows()).length) + 1)"
                :name="row[1].name"
                :disabled="row[1].disabled"
                v-if="row[1].fieldType === 'input' && !row[1].autocomplete"
                v-model="form[row[1].name]"
                data-fieldtype="input"
                @focus="updateFocusedField"
                @blur="row[1].name.includes('address_') ? handleAddressFieldBlurEvent(row[1].name) : null"
                @change="() => change(row[1].name)"
              />
              <MoneyField
                class="keynav"
                style="padding-left: 12px;"
                :tabindex="row[1].tabIndex"
                :ref="idPrefix + (index + (Object.keys(getRows()).length) + 1)"
                :id="idPrefix + (index + (Object.keys(getRows()).length) + 1)"
                :name="row[1].name"
                :disabled="row[1].disabled"
                :decimals="row[1].decimals || undefined"
                v-if="row[1].fieldType === 'money'"
                v-model="form[row[1].name]"
                data-fieldtype="input"
                @focus="updateFocusedField"
                @blur="row[1].name.includes('address_') ? handleAddressFieldBlurEvent(row[1].name) : null"
                @change="() => change(row[1].name)"
              />
              <el-autocomplete
                class="keynav"
                placeholder="Type to search..."
                @select="handleSelect"
                :tabindex="row[1].tabIndex"
                :ref="`autocomplete__${idPrefix + (index + (Object.keys(getRows()).length) + 1)}`"
                :id="idPrefix + (index + (Object.keys(getRows()).length) + 1)"
                :name="row[1].name"
                :disabled="row[1].disabled"
                :fetch-suggestions="row[1].searchAsync
                  ? querySearchAsync
                  : (query, cb) => autocompleteLocalSearch({ query, ref: `autocomplete__${idPrefix + (index + (Object.keys(getRows()).length) + 1)}`, field: row[1] }, cb)"
                :props="{ label: 'label', value: 'value' }"
                :trigger-on-focus="row[1].triggerOnFocus"
                v-else-if="row[1].fieldType === 'autocomplete'"
                v-model="form[row[1].name].label"
                data-fieldtype="autocomplete"
                @blur="row[1].name.includes('address_') ? handleAddressFieldBlurEvent(row[1].name) : null"
                @change="() => change(row[1].name)">
              </el-autocomplete>
              <el-select
                class="keynav"
                v-else-if="row[1].fieldType === 'select' && form[row[1].name].hasOwnProperty('value')"
                v-model="form[row[1].name].value"
                :tabindex="row[1].tabIndex"
                :ref="idPrefix + (index + (Object.keys(getRows()).length) + 1)"
                :id="idPrefix + (index + (Object.keys(getRows()).length) + 1)"
                :name="row[1].name"
                :filterable="row[1].filterable"
                :multiple="row[1].multiple"
                :loading="null"
                :placeholder="row[1].filterable ? 'Search' : 'Select option'"
                no-match-text=" "
                @change="() => handleSelectChange(row[1].name)"
                data-fieldtype="select">
                <el-option
                  v-for="item in row[1].choices ? row[1].choices : nonAsyncSuggestions[row[1].name]"
                  :key="item.value"
                  :label="row[1].choices ? item.display_name : item.label"
                  :value="item.value"
                />
              </el-select>
              <el-select
                class="keynav"
                v-else-if="row[1].fieldType === 'select' && !form[row[1].name].hasOwnProperty('value')"
                v-model="form[row[1].name]"
                :tabindex="row[1].tabIndex"
                :ref="idPrefix + (index + (Object.keys(getRows()).length) + 1)"
                :id="idPrefix + (index + (Object.keys(getRows()).length) + 1)"
                :name="row[1].name"
                :filterable="row[1].filterable"
                :multiple="row[1].multiple"
                :loading="null"
                :placeholder="row[1].filterable ? 'Search' : 'Select option'"
                no-match-text=" "
                @change="() => handleSelectChange(row[1].name)"
                data-fieldtype="select">
                <el-option
                  v-for="item in row[1].choices ? row[1].choices : nonAsyncSuggestions[row[1].name]"
                  :key="item.value"
                  :label="row[1].choices ? item.display_name : item.label"
                  :value="item.value"
                />
              </el-select>
              <el-checkbox
                class="keynav form-checkbox"
                :tabindex="row[1].tabIndex"
                :ref="idPrefix + (index + (Object.keys(getRows()).length) + 1)"
                :id="idPrefix + (index + (Object.keys(getRows()).length) + 1)"
                :name="row[1].name"
                v-else-if="row[1].fieldType === 'checkbox'"
                v-model="form[row[1].name]"
                data-fieldtype="checkbox"
                @focus="updateFocusedField"
                @change="() => change(row[1].name)"
              />
              <el-input
                class="keynav"
                type="textarea"
                :tabindex="row[1].tabIndex"
                :ref="idPrefix + (index + (Object.keys(getRows()).length) + 1)"
                :id="idPrefix + (index + (Object.keys(getRows()).length) + 1)"
                :name="row[1].name"
                :rows="1"
                v-else-if="row[1].fieldType === 'textarea'"
                v-model="form[row[1].name]"
                data-fieldtype="input"
                @focus="updateFocusedField"
                @change="() => change(row[1].name)"
              />
              <el-input
                class="keynav"
                placeholder="YYYY-MM-DD"
                :ref="idPrefix + (index + (Object.keys(getRows()).length) + 1)"
                :id="idPrefix + (index + (Object.keys(getRows()).length) + 1)"
                :name="row[1].name"
                v-else-if="row[1].fieldType === 'date'"
                v-model="form[row[1].name]"
                data-fieldtype="input"
                @focus="updateFocusedField"
                @blur="formatDateFields"
                @change="() => change(row[1].name)"
              />
            </td>
          </tr>
        </table>
      </el-form>
    </el-row>
    <el-row justify="end" align="middle" class="helper-text-wrapper" v-if="fieldsHaveNoteText">
      <el-tag :type="'gray'" :style="`visibility: 'visible'};`">
        {{ fieldsHaveNoteText }}
      </el-tag>
    </el-row>
  </div>
</template>

<script>
  import validFormFields from '@/utils/validElementFormInputs'
  import { navigateHeader } from '@/utils/helpers/NavigateForm'
  import filterInvalidDOMElements from '@/utils/helpers/FilterInvalidDOMElements'
  import buildAddressString from '@/utils/helpers/BuildAddressString'
  import buildNoDataObject from '@/utils/helpers/BuildNoDataObject'
  import buildLabelString from '@/utils/helpers/BuildLabelString'
  import { hideOpenSuggestionMenus, shouldDisableArrowNav, handleTabKey } from '@/utils/helpers/DataEntryViews/ArrowNavHelper'
  import MoneyField from '@/components/InputComponents/MoneyField.vue'
  import { convertCurrencyHTMLCodeToSymbol } from '@/utils/helpers/StringOperations'
  import { searchMixins } from '@/Mixins/SearchMixins'

  export default {
    components: {
      MoneyField
    },
    mixins: [ searchMixins ],
    props: {
      fields: Array,
      form: Object,                               // When multiple instances of this component are loaded in the DOM, it is necessary to
      idPrefix: String,                           // <--- pass an id prefix in order to prevent duplicate ids in the DOM. Whatever prefix you pass,
      nonAsyncSuggestions: Object,                // be sure to append a '-' (dash) to it (i.e. "a-") so that navigateForm() works for each instance.
      formChanged: Boolean,
      modalOpen: Boolean,
      errMsg: {
        'type': String,
        'required': false,
        'default': ''
      }
    },
    data () {
      return {
        suggestions: {
          active: '',
          account: [],
          default_accounts: [],
          petty_cash_account: [],
          default_account_cash: [],
          default_account_clearing: [],
          default_account_deposits: [],
          default_account_discount: [],
          parent_account: [],
          address: [],
          address_id: [],
          address_billing: [],
          address_contact: [],
          address_physical: [],
          address_mailing: [],
          address_mailing_state: [],
          address_state: [],
          address_physical_state: [],
          address_billing_state: [],
          address_contact_state: [],
          batch: [],
          currency: [],
          period: [],
          source_code: [],
          vendor: []
        },
        loading: false,
        searchTimeout: null,
        focusedField: null,
        fieldsHaveHelperText: false
      }
    },
    methods: {
      /**
       * Updates the focusedField data property with the name of the currently focused field
       * @param e   Focus event
       */
      updateFocusedField (e) {
        if (e && e.srcElement && e.srcElement.name) {
          this.focusedField = e.srcElement.name
        } else {
          this.focusedField = null
        }
      },
      /**
       * Handles form changes
       * @param field   The field name
       */
      change (field) {
        this.$emit('update:form', this.form)
        this.$emit('formChanged', field)
      },
      /**
       * Handles changes to a select field
       * @param field   The field name
       */
      handleSelectChange (field) {
        this.checkFormField(field)
        this.change(field)
      },
      /**
       * Returns the rows that make up the form
       */
      getRows () {
        let ret = []
        this.fields.forEach((field, index) => {
          if (!(index & 1)) {
            ret.push([this.fields[index], this.fields[index + 1]])
          }
        })
        return ret
      },
      /**
       * Returns the name of the currently active element
       */
      getFieldName () {
        return document.activeElement.name
      },
      /**
       * Determines whether navigation should occur based on the key being pressed
       * @param e   Keydown event
       */
      handleKeydown (e) {
        const fieldName = this.getFieldName()
        if ([37, 38, 39, 40, 13].includes(e.keyCode)) {
          this.navigateForm(e)
        } else if (e.keyCode === 9) {
          handleTabKey(this)
        } else {
          let field = this.form[fieldName]
          if (field && field.hasOwnProperty('value')) field.value = ''
        }
        this.checkFormField(fieldName)
      },
      /**
       * Checks whether a form field is valid
       * @param fieldName   The name of the field to check
       */
      checkFormField (fieldName) {
        const field = this.form[fieldName]
        const fieldMeta = this.fields.find(v => v.name === fieldName)
        if (field && field.hasOwnProperty('value') && fieldMeta.required) {
          if (!field.value) {
            document.getElementsByName(fieldName)[0].style.backgroundColor = '#ff49493d'                    // Set color to indicate that value has been set
          } else {
            document.getElementsByName(fieldName)[0].style.backgroundColor = '#fff'                         // Set color to indicate that value has been set
          }
        }
      },
      /**
       * Allows keyboard navigation throughout the form
       * @param e   Keydown event
       */
      navigateForm (e) {                                                                                    // Enable form navigation with arrow keys (and some others)
        if (shouldDisableArrowNav(this, e)) return false                                                                                      //     autocomplete or select that is displaying a dropdown,  with suggestions. In such a case,
        hideOpenSuggestionMenus(this)                                                                       // --- Hide any open suggestion menus before navigating to next field
        const id = e.srcElement.closest('.keynav').className.includes('el-select')                          // --- See ** below
          ? e.srcElement.closest('.el-input').id                                                            //
          : e.srcElement.closest('.keynav').id                                                              //
        const idParts = id.split('-')                                                                       // --- Each form element has a unique id consisting of a prefix letter and a number. This separates the id
        const idPrefix = idParts[0]                                                                         //     into an array containing the prefix at index 0...
        const idNum = parseInt(idParts[1])                                                                  //     and the number at index 1
        const targetId = navigateHeader(e, idNum, (Math.round(this.fields.length / 2)), 2)                  // --- This gets the id of the element the user is trying to navigate to (targetId), which depends on the key
        const elsFoundById = document.getElementById(`${idPrefix}-${targetId}`)
        let els
        if (elsFoundById && elsFoundById.children.length) {
          els = elsFoundById.getElementsByTagName('*')
        } else if (elsFoundById && elsFoundById.tagName === 'INPUT') {
          return elsFoundById.focus()
        }
        let validEls = filterInvalidDOMElements(els, validFormFields)                           //     filter children that *aren't* input elements (<input>, <select>, <checkbox>, etc.)...
        if (validEls && validEls[0]) return validEls[0].focus()                                                                   //     then we can finally focus on the input element.
      },
      // /**
      //  * Handles searching for non-remote autocomplete fields
      //  * @param args
      //  * @param cb
      //  */
      // autocompleteLocalSearch ({ query, ref, options }, cb) {
      //   const handleSearch = () => {
      //     let ret = options.searchable.reduce((a, e, i) => e.includes(query.toLowerCase().replace('-', '')) ? a.concat(i) : a, [])
      //     return ret.map(v => options.opts[v])
      //   }
      //   return new Promise((resolve, reject) => {
      //     this.searchTimeout = setTimeout(() => {
      //       let results = query ? handleSearch() : options.opts
      //       cb(results)
      //       resolve()
      //     })
      //   })
      //     .then(() => this.highlightFirstAutocompleteResult(ref))
      //     .catch(e => console.log(e))
      // },
      // querySearch (queryString, cb) {                                                                       // Handles loading suggestions (no ajax fetch)
      //   this.clearActiveSuggestionListIndicator()                                                           // --- Reset active suggestion list indicator
      //   const { name } = document.activeElement
      //   let results = queryString
      //     ? this.nonAsyncSuggestions[name].filter(this.createFilter(queryString))
      //     : this.nonAsyncSuggestions[name]
      //   this.setActiveSuggestionListIndicator(name)
      //   cb(results)
      // },
      /**
       * Handles async/remote autocomplete searches
       * @param query
       * @param cb
       */
      querySearchAsync (query, cb) {
        const executeSearch = () => {
          this.clearActiveSuggestionListIndicator('')
          const el = document.activeElement.name
          let results = query
            ? this.suggestions[el].filter(this.createFilter(query))
            : this.suggestions[el]
          if (query && query !== '' && query.length >= 1) {
            let name
            let queryObj = { search: query }
            switch (el) {
              case 'account':
              case 'parent_account':
                name = 'accounts'
                break
              case 'default_accounts':
              case 'petty_cash_account':
                queryObj['type__in'] = 'EXPENSE,EXPENSE_ATL,EXPENSE_BTL'
                name = 'accounts'
                break
              case 'default_account_cash':
                queryObj['type__in'] = 'ASSET'
                name = 'accounts'
                break
              case 'default_account_clearing':
                queryObj['type__in'] = 'LIABILITY'
                name = 'accounts'
                break
              case 'default_account_deposits':
              case 'default_account_discount':
                queryObj['type__in'] = 'ASSET'
                name = 'accounts'
                break
              case 'address':
              case 'address_id':
              case 'address_physical':
              case 'address_mailing':
              case 'address_billing':
              case 'address_contact':
                name = 'addresses'
                break
              case 'batch':
                name = 'batches'
                break
              case 'currency':
                name = 'currencies'
                break
              case 'vendor':
                name = 'vendors'
                break
              case 'source_code':
                name = 'sourcecodes'
            }
            this.$store.dispatch('searchWithQuery', { endpoint: name, query: queryObj })
              .then(r => {
                this.loadingOptions = false // TODO: this doesn't reference an actual variable
                if (r && r.count) {
                  results = Object.values(r.entities[name]).map(v => {
                    let ret = {}
                    ret.label = name !== 'addresses' ? buildLabelString(v) : buildAddressString(v)
                    ret[el] = v.id
                    return ret
                  })
                  this.setActiveSuggestionListIndicator(el, true)
                  cb(results)
                } else {
                  cb([buildNoDataObject(el)])
                }
              })
              .then(() => {
                const { $refs } = this
                for (let r in $refs) {
                  if (r.includes('autocomplete') && $refs[r][0] && $refs[r][0].suggestions.length) {
                    this.$refs[r][0].highlight(0)
                  }
                }
              })
              .catch(e => {
                console.log(e)
                cb([buildNoDataObject(el)])
              })
          }
        }
        if (this.searchTimeout) clearTimeout(this.searchTimeout)
        this.searchTimeout = setTimeout(() => executeSearch(), 200)
      },
      createFilter (query) {
        const { name } = document.activeElement
        return (link) => link[name].indexOf(query.toLowerCase()) === 0
      },
      setActiveSuggestionListIndicator (field, asyncSuggestionList) {
        asyncSuggestionList ? this.suggestions.active = field : this.nonAsyncSuggestions.active = field
      },
      clearActiveSuggestionListIndicator () {
        if (this.suggestions) this.suggestions.active = ''
        if (this.nonAsyncSuggestions) this.nonAsyncSuggestions.active = ''
      },
      /**
       * Handles autocomplete suggestion selection
       * @param selection
       */
      handleSelect (selection) {
        const targetField = Object.keys(selection)[1]
        if (selection.label === 'No data' && !selection[Object.keys(selection)[1]]) {
          this.form[targetField] = { label: '', value: '' }
          return selection.label
        }
        this.form[targetField].label = selection.label
        this.form[targetField].value = selection[Object.keys(selection)[1]]
        this.checkFormField(targetField)                                                                        // Make sure selection is valid
        this.$emit('formChanged', targetField)
        return selection.label
      },
      handleAddressFieldBlurEvent (fieldName) {
        this.$emit('addressFieldBlurEvent', fieldName)
      },
      /**
       * Formats date fields to YYYY-MM-DD format
       */
      formatDateFields () {
        this.$emit('formatDateFields')
      },
      /**
       * Checks whether at least one field has a 'helperText' property which contains a value
       */
      checkIfFieldsHaveHelperText () {
        this.fieldsHaveHelperText = this.fields.some(field => field.help_text)
      },
      /**
       * Because element-ui nests <el-autocomplete> and <el-checkbox>s' actual <input> DOM node within a div, we can't set an
       * event listener directly on <el-autocomplete> or <el-checkbox> because it won't bind to <input>. So, we have to explicitly
       * set it when the component mounts.
       */
      initializeComponent () {
        for (let r in this.$refs) {
          let ref = this.$refs[r] && this.$refs[r].length ? this.$refs[r][0] : null
          if (!ref || !ref.$el || !ref.$el.dataset.fieldtype) continue
          const el = ref.$el
          let nested
          switch (el.dataset.fieldtype) {
            case 'autcomplete':
            case 'checkbox':
            case 'select':
              nested = el.getElementsByTagName('input')[0]
              break
          }
          if (nested) {
            el.removeAttribute('data-fieldtype')
            nested.setAttribute('data-fieldtype', el.dataset.fieldtype)
            nested.setAttribute('autocomplete', 'force_off')
            nested.addEventListener('focus', (e) => this.updateFocusedField(e))
          }
        }
      },
      /**
       * Resets data attributes to their original state
       */
      resetComponent () {
        this.loading = false
        this.searchTimeout = null
        this.focusedField = null
      },
      /**
       * Programatically sets the focus on the first focusable field
       */
      focusOnFirstField () {
        let targetRef = this.$refs[`${this.idPrefix}1`] ? this.$refs[`${this.idPrefix}1`][0] : null
        if (targetRef && targetRef.$el && targetRef.$el.focus) {
          const { $el } = targetRef
          if ($el.dataset && $el.dataset.fieldtype && $el.dataset.fieldtype === 'input' && $el.tagName !== 'INPUT') {
            $el.getElementsByTagName('input')[0].focus()
          }
        }
      }
    },
    computed: {
      /**
       * Returns the helper text associated with the currently focused field, if any
       * @return {*}
       */
      helperText () {
        if (this.focusedField) {
          const field = this.fields.find(field => field.name === this.focusedField)
          let helpText = (field && field.help_text) ? field.help_text : null
          helpText = convertCurrencyHTMLCodeToSymbol(helpText)
          return helpText
        }
      },
       /**
       * Checks whether at least one field has a 'noteText' property which contains a value
       */
      fieldsHaveNoteText () {
        const field = this.fields.find(field => field.note_text)
        return field ? field.note_text : null
      }
    },
    watch: {
      modalOpen () {
        if (this.modalOpen) {
          this.focusOnFirstField()
        }
      }
    },
    created () {
      this.checkIfFieldsHaveHelperText()
    },
    mounted () {
      this.initializeComponent()
      if (this.modalOpen) {
        this.focusOnFirstField()
      }
    }
  }
</script>

<style>
  td input {
    border: none !important;
    height: 22px !important;
  }
  td textarea {
    border: none !important;
    height: 22px !important;
  }
  .el-autocomplete {
    width: 100%;
  }
</style>

<style scoped>
  .helper-text-wrapper {
    display: inline-block;
  }
  .helper-text-wrapper span {
    margin-bottom: 12px;
    width: 100%;
    display: inline-block;
    white-space: normal;
  }
  /*Table style properties*/
  table {
    width: 100%;
    margin-bottom: 1em;
    border-collapse: collapse;
  }
  td {
    padding: 0.2em;
    border: 1px solid #ccc;
    background-color: #ffffff;
    font-size: 12px;
  }
  td:first-child {
    text-align: right;
    background-color: #efefef;
    padding: 3px;
  }
  td:nth-child(2) {
    text-align: left;
  }
  td:nth-child(3) {
    text-align: right;
    background-color: #efefef;
    padding: 3px;
  }
  td:nth-child(4) {
    text-align: left;
  }
  .el-table .modified-row {
    background: #c9e5f5;
  }
  .form-checkbox {
    padding: 0 10px;
  }
  .el-select {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/NewEntityForm.vue